module.exports = __webpack_public_path__ + "assets/img/logo.8332001c.png";